// extracted by mini-css-extract-plugin
module.exports = {"input":"styles__input___1J3cG"};